import picture from './picture';
import damage_report from './damage_report';

export default {
  picture,
  damage_report
};
